(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-brush-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', async (event) => {
  if (!(event.target instanceof HTMLFormElement)) return;
  const form = event.target;
  const button = event.submitter;
  if (!form.matches('.ff-product-form') || !(button instanceof HTMLButtonElement) || button.name !== 'add') return;
  const feedback = form.querySelector('[data-cart-feedback]');
  const message = feedback?.querySelector('[data-cart-message]');
  const cartLink = feedback?.querySelector('a');
  if (!feedback || !message || !cartLink) return;
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  const root = window.Shopify.routes.root;
  const formData = new FormData(form);
  const addedQuantity = Number(formData.get('quantity') || 1);
  form.dataset.submitting = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  feedback.hidden = true;
  cartLink.hidden = true;
  try {
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    const result = await response.json();
    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || feedback.dataset.errorMessage);
    }
    message.textContent = feedback.dataset.addedMessage;
    cartLink.hidden = false;
    feedback.hidden = false;
    // A second cart fetch can replay Shopify's native product-added event.
    for (const count of document.querySelectorAll('.ff-cart-link span')) {
      const previousCount = Number(count.textContent);
      if (Number.isFinite(previousCount)) count.textContent = String(previousCount + addedQuantity);
    }
  } catch (error) {
    message.textContent = error.message || feedback.dataset.errorMessage;
    cartLink.hidden = false;
    feedback.hidden = false;
  } finally {
    delete form.dataset.submitting;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});

  } catch(e) { console.error(e); }
})();
})();
